
// SVG Icon: info
export default { id: "terriajs-info" };
export const id = "terriajs-info";
export const name = "info";
